import React, { useEffect } from "react";
import {
  PrevButton,
  NextButton,
  usePrevNextButtons
} from "./ArrowButtons";
import {
  DotButton,
  useDotButton
} from "./DotButton";
import {
  SelectedSnapDisplay,
  useSelectedSnapDisplay
} from "./SnapDisplay";
import useEmblaCarousel from "embla-carousel-react";
import cn from "classnames";
import "./embla.scss";

const EmblaCarousel = ({ children, options = {}, as = "div", className, controlsClassName, showButtons, showDots, showSnapCount, initialSlideIdx }) => {
  
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi); 

  const { selectedSnap, snapCount } = useSelectedSnapDisplay(emblaApi);
  
  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi);
  
  const El = as;
  
  useEffect(() => {
    if (!emblaApi) return;
    if (initialSlideIdx && initialSlideIdx !== null) {
      const { slideRegistry } = emblaApi.internalEngine();
      const snapIdx = slideRegistry.findIndex((group) => group.includes(initialSlideIdx));
      // console.log("snap", snapIdx);
      if (typeof snapIdx !== 'undefined') {
        emblaApi.scrollTo(snapIdx);
      }
    }
  }, [emblaApi]);

  return (
    <section className={cn("embla", className)} data-snapcount={snapCount}>
      <div className="embla__viewport" ref={emblaRef}>
        <El className="embla__container">
          {React.Children.map(children, (child, i) => {
            if (child && child !== null) {
              return React.cloneElement(child, {
                [`data-active`]: i === selectedSnap,
              });
            }
            return null;
          })}
        </El>
      </div>

      <div className={cn("embla__controls", controlsClassName)}>
        {showSnapCount && <SelectedSnapDisplay
          selectedSnap={selectedSnap}
          snapCount={snapCount}
        />}        
        {showButtons && <div className="embla__buttons">
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>}
        {showDots && <div className="embla__dots">
          {scrollSnaps.map((_, index) => (
            <DotButton
              key={index}
              onClick={() => onDotButtonClick(index)}
              className={cn("embla__dot", {"embla__dot--selected": index === selectedIndex})}
            >
              <span className="embla__dot--inner" />
              <span className="visually-hidden">{index + 1}</span>
            </DotButton>
          ))}
        </div>}
      </div>
    </section>
  );
};

export default EmblaCarousel;
